export default "{\n    \"label\": \"Ongoing Incident\",\n    \"options\": {\n        \"true\": \"Has ongoing incident\"\n    }\n}\n"